function makeAddressForm(data) {
	const geoCode = data.geoCode[0];
	const addressComp = geoCode.address_components;
	const coordinate = data.latLng;

	let formData = {
		address_id: '',
		type: '',
		placeId: String(geoCode.place_id),
		fullAddress: String(geoCode.formatted_address),
		unit: '',
		street: '',
		city: '',
		province: '',
		country: '',
		postalCode: '',
		coordinate: Object(coordinate),
	};

	for (let i = 0; i < addressComp.length; i++) {
		const type = addressComp[i].types[0];
		if (type === 'street_number') formData.street = addressComp[i].short_name;
		if (type === 'route') formData.street = formData.street.concat(' ', addressComp[i].short_name);
		if (type === 'neighborhood')
			formData.street = formData.street.concat(' ', addressComp[i].short_name);
		if (type === 'locality') formData.city = addressComp[i].short_name;
		if (type === 'administrative_area_level_1') formData.province = addressComp[i].short_name;
		if (type === 'country') formData.country = addressComp[i].short_name;
		if (type === 'postal_code') formData.postalCode = addressComp[i].short_name;
	}
	return formData;
}

export default makeAddressForm;
